import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { Erzeugungsanlage } from '../../domain/model/erzeugungsanlage';
import { NetzbetreiberType } from '../../domain/model/netzbetreibertype';
import { RoutingService } from '../../service/common/routing/routing.service';
import { Sort } from '@angular/material/sort';
import { Router } from '@angular/router';

@Component({
    selector: 'tnb-erzeugungsanlage-table',
    templateUrl: './erzeugungsanlage-table.component.html',
    styleUrls: [
        './erzeugungsanlage-table.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlageTableComponent implements OnChanges {
    router = inject(Router);
    routingService = inject(RoutingService);

    public static readonly DEFAULT_COLUMNS = [
        'westnetzId',
        'netzzuordnung.ortsname',
        'netzzuordnung.stationsname',
        'netzzuordnung.trafoFeldName',
        'netzzuordnung.deactivated',
        'anlagentyp.name',
        'installierteLeistungKW',
        'abregelbareLeistungKW',
    ];
    public static readonly WESTNETZ_COLUMNS = [
        'netzzuordnung.netzbetreiber.name',
        'netzzuordnung.netzbetreiber.teilgebiet',
    ];

    @Input()
    public erzeugungsanlagen: Erzeugungsanlage[];

    public columnsToDisplay = [];

    @Input()
    public netzbetreiberType: NetzbetreiberType;

    @Input()
    public sortDirection: string;

    @Input()
    public sortActive: string;

    @Output()
    public sortChange = new EventEmitter<Sort>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.netzbetreiberType) {
            this.netzbetreiberType = changes.netzbetreiberType.currentValue;
        }

        this.columnsToDisplay = this.generateColumnsToDisplay(this.netzbetreiberType);
    }

    navigateToDetails(erzeugungsanlage: Erzeugungsanlage): void {
        this.router.navigate([
            this.routingService.erzeugungsanlagePath(),
        ], {
            queryParams: { erzeugungsanlage: erzeugungsanlage.westnetzId },
            queryParamsHandling: 'merge',
        });
    }

    public _sortChange($event: Sort) {
        if ($event.direction === '') {
            $event.active = '';
        }
        this.sortChange.emit($event);
    }

    private generateColumnsToDisplay(netzbetreiberType: NetzbetreiberType): string[] {
        if (netzbetreiberType && netzbetreiberType === 'WESTNETZ') {
            return [
                ...ErzeugungsanlageTableComponent.WESTNETZ_COLUMNS,
                ...ErzeugungsanlageTableComponent.DEFAULT_COLUMNS,
            ];
        } else {
            return [
                ...ErzeugungsanlageTableComponent.DEFAULT_COLUMNS,
            ];
        }
    }
}
